/**
 * Format values for DataGrid datetime columns: dd/MM/yy HH:mm (24h, local time).
 * @param {unknown} value ISO string, Date, or timestamp-compatible input
 * @returns {string} Formatted time or "—" when empty / invalid
 */
export function formatGridDateTime(value) {
  if (value == null || value === "" || value === "—") return "—";
  if (typeof value === "string" && value.trim() === "") return "—";

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) {
    return typeof value === "string" ? value : "—";
  }

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yy} ${hh}:${min}`;
}

/**
 * Numeric timestamp for sorting (DataGrid valueGetter). Nulls sort last.
 * @param {unknown} value
 * @returns {number | null}
 */
export function gridDateTimeSortValue(value) {
  if (value == null || value === "" || value === "—") return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.getTime();
}
